import { render, staticRenderFns } from "./AudienceSummaryPlaceholder.vue?vue&type=template&id=090fd1cf&scoped=true&"
import script from "./AudienceSummaryPlaceholder.vue?vue&type=script&lang=js&"
export * from "./AudienceSummaryPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./AudienceSummaryPlaceholder.vue?vue&type=style&index=0&id=090fd1cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090fd1cf",
  null
  
)

export default component.exports